import { parseQueries } from "@ds/utils/query";
import { DSApi } from "@ds/services/ds-api";
import { type ApiService, type ApiServiceConfig } from "@ds/services/types";

interface AssetsServiceConfig extends ApiServiceConfig {
  api: DSApi;
}

class AssetsService implements ApiService {
  private config: AssetsServiceConfig = {
    api: {} as DSApi,
  };

  configure(cfg: AssetsServiceConfig) {
    this.config = { ...cfg };
  }

  async getAssets(queryInfo: QueryInfo, pagination: Pagination) {
    const queries = parseQueries(queryInfo, pagination);
    return this.config.api.get<QueryOutput<Asset>>("/assets/", queries);
  }

  async getAsset(assetId: number) {
    return this.config.api.get<Asset>(`/assets/${assetId}`);
  }

  async createAsset(asset: Asset) {
    return this.config.api.post<Asset>("/assets/", asset);
  }

  async deleteAssets(ids: number[]) {
    return this.config.api.delete<Asset>("/assets/", { ids });
  }
}

export const assetsService = new AssetsService();
